import React from "react"
import autobind from "class-autobind"
import CircularProgress from "material-ui/CircularProgress"
import ImageLoader from "../../../components/misc/ImageLoader"
import Face from "material-ui/svg-icons/image/tag-faces"
import BuildIcon from "material-ui/svg-icons/action/build"
import Clock from "material-ui/svg-icons/action/schedule"
import Exit from "material-ui/svg-icons/action/exit-to-app"
import MapLoader from "../../map/MapLoader"
import { IUserDocument, IPunchDocument, IObjectTimecardDocument } from "../../../models"
import * as api from "../../../api"
import { amber500 } from "material-ui/styles/colors"
import strings from "../../../localization/strings"
import moment from "moment"
import AccountStore from "../../../stores/AccountStore"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import AppStateStore from "../../../stores/AppStateStore"
import { EventAction, EventType, IWorkHistoryDay } from "../../../models/data/punch/WorkHistoryDay"
interface IProps {
    dayNum: number
    timecard: IObjectTimecardDocument
    imageS3Url: string
}
interface IState {
    loading: boolean
    users: IUserDocument[]
    punches: IPunchDocument[]
    workhistoryDay: IWorkHistoryDay
}

const eventName = (eventType: EventType) => {
    if (eventType === EventType.Enter) {
        return "Entered"
    } else if (eventType === EventType.Exit) {
        return "Exited"
    }
    return ""
}

const eventAction = (eventAction: EventAction) => {
    var action = "";
    if (eventAction === EventAction.Clicked) {
        action = "Clicked"
    } else if (eventAction === EventAction.Punch) {
        action = "Punched"
    }
    else if (eventAction === EventAction.Dismissed) {
        action = "Dismissed"
    }
    action += " punch capture reminder."

    if (eventAction == EventAction.None) {
        action = "";
    }

    return action;
}
export default class EmployeeWorkHistoryDrawerContent extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            users: [],
            punches: [],
            workhistoryDay: null
        }
        autobind(this)
    }

    componentDidMount() {
        this.loadData()
    }

 

    loadData() {
        this.setState({ loading: true })
        api.getWorkHistoryPunches({ referenceDateInUtc: this.props.timecard.MasterTimecard.TimecardWeeks[0].Days[this.props.dayNum].StartDayTime, userId: this.props.timecard.Employee.Id })
            .then(res => this.setState({ workhistoryDay: res.data }))
            .finally(() => this.setState({ loading: false }))
    }

    getLevelLabel(hierarchyItemId) {
        if (hierarchyItemId) {
            const levelName = hierarchyHelper.getHierarchyItemNameByHierarchyId(hierarchyItemId)
            if (!levelName) return ""
            const showLevelName = levelName.length < 20 ? levelName : levelName.substr(0, 19) + "..."
            return (
                <span>
                    {hierarchyHelper.getHierarchyDefinitionNameByHierarchyId(hierarchyItemId)}: {showLevelName}
                </span>
            )
        } else if (AccountStore.getCurrentAccount()) {
            return (
                <span>
                    {strings.Account}: {AccountStore.getCurrentAccount().Name}
                </span>
            )
        } else {
            return ""
        }
    }

    render() {
        const { workhistoryDay } = this.state
        let hierarchyInfo
        return (
            <div style={{ textAlign: "center", paddingLeft: 120, paddingRight: 120, paddingTop: 35 }}>
                {this.state.loading ?
                    <CircularProgress /> :
                    <div style={{ position: "relative" }}>
                        <div style={{ width: 60, height: 60, borderRadius: "50%", border: "10px solid " + AppStateStore.getFrontEndSettings().UISettings.AccentColor }}>
                            {workhistoryDay && workhistoryDay.EmployeeProfileImageS3Url ?
                                <ImageLoader url={workhistoryDay.EmployeeProfileImageS3Url} fixedHeight={110} avatar={true} /> :
                                <Face style={{ fill: amber500, width: 55, height: 55, margin: 3 }} />
                            }
                            <div style={{ position: "absolute", top: 35, left: 125 }}>
                                <div style={{ textAlign: "left", fontSize: 17, fontWeight: 500 }}>
                                    {workhistoryDay && workhistoryDay.Hours === 0 && workhistoryDay.Minutes === 0 && strings.There_is_no_work_history}
                                    {workhistoryDay && workhistoryDay.Hours > 0 && `${workhistoryDay.Hours}h`} {workhistoryDay && `${workhistoryDay.Minutes > 0 ? workhistoryDay.Minutes : "00"}min`}
                                </div>
                                <div>{hierarchyInfo}</div>
                            </div>
                        </div>
                        <div style={{ position: "absolute", top: 80, left: 35 }}>
                            {workhistoryDay && workhistoryDay.Entries.map((punchSet, index) => {

                                const dayTimeInfo = (punchSet.Hours > 0 ? punchSet.Hours + "h  " : "") + (punchSet.Minutes < 10 ? "0" + punchSet.Minutes + "min" : punchSet.Minutes + "min")
                                let locations = []
                                if (punchSet.PunchInLatitude && punchSet.PunchInLongitude) {
                                    locations.push({ lat: punchSet.PunchInLatitude, lng: punchSet.PunchInLongitude })
                                } if (punchSet.PunchOutLatitude && punchSet.PunchOutLongitude) {
                                    locations.push({ lat: punchSet.PunchInLatitude, lng: punchSet.PunchOutLongitude })
                                }
                                return (
                                    <div
                                        key={index}
                                        style={{ position: "relative", marginBottom: 5 }}
                                    >
                                        <div style={{ width: 3, borderRight: "3px solid " + AppStateStore.getFrontEndSettings().UISettings.AccentColor, display: "inline-block", height: index === 0 ? 75 : 250 }} />
                                        <div style={{ display: "inline-block" }}>
                                            <div style={{ position: "absolute", left: 25, bottom: -160, backgroundColor: "#CCDBF8", width: 640, height: 210, textAlign: "left" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingLeft: 17, paddingRight: 17, paddingTop: 11, }}>
                                                    <div style={{ fontSize: 12, fontWeight: 500, }}>
                                                        {this.getLevelLabel(punchSet.HierarchyItemId)} - {workhistoryDay.Name}
                                                    </div>
                                                    <div style={{ fontSize: 12, }}>
                                                        {!punchSet.IsGeoFence && strings.Hours_Worked}
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", alignItems: "flex-start", paddingLeft: 17, paddingRight: 17, marginTop: 30, }}>
                                                    <div style={{ width: 35, height: 35, borderRadius: "50%", border: `7px solid ${AppStateStore.getFrontEndSettings().UISettings.AccentColor}` }}>
                                                        {workhistoryDay.EmployeeProfileImageS3Url ?
                                                            <ImageLoader
                                                                url={workhistoryDay.EmployeeProfileImageS3Url}
                                                                fixedHeight={65}
                                                                avatar={true}
                                                                src={"/users/profileimage/" + workhistoryDay.EmployeeProfileImageS3Url}
                                                            /> :
                                                            <Face style={{ fill: "#9E9E9E", width: 37, height: 37, margin: -1 }} />
                                                        }
                                                    </div>
                                                    {punchSet.IsGeoFence && <div style={{ marginLeft: 18, fontSize: 16, fontWeight: 600, marginTop: 2 }}>
                                                        {eventName(punchSet.EventType)} Geo Fence for {punchSet.JobName != null ? punchSet.JobName : punchSet.HierarchyItemLabel} at
                                                        <br />
                                                        {`(${moment.utc(punchSet.EventTime).format("MM/DD/YYYY hh:mm a")})`}. {eventAction(punchSet.EventAction)}
                                                    </div>}
                                                    {!punchSet.IsGeoFence && <div style={{ display: "flex", flexDirection: "column", marginTop: 10, marginLeft: 30, marginRight: "auto", gap: 10 }}>
                                                        <div style={{ fontSize: 30, marginBottom: 10, fontWeight: 400 }}>
                                                            {punchSet.PunchInTime && punchSet.PunchOutTime ? dayTimeInfo : strings.Missing}
                                                        </div>
                                                        <div style={{ display: "flex", gap: 30, }}>
                                                            <div style={{ fontWeight: 600 }}>
                                                                <div style={{ display: "inline-block", width: 90, fontWeight: 600 }}>
                                                                    {strings.Punched_In}:
                                                                </div>
                                                                {punchSet.PunchInTime ? moment.utc(punchSet.PunchInTime).format("hh") + ":" + moment.utc(punchSet.PunchInTime).format("mm") + " " + moment.utc(punchSet.PunchInTime).format("a") : ""}
                                                            </div>
                                                            <div style={{ fontWeight: 600 }}>
                                                                <div style={{ display: "inline-block", width: 90, fontWeight: 600 }}>
                                                                    {strings.Punched_Out}:
                                                                </div>
                                                                {punchSet.PunchOutTime ? moment.utc(punchSet.PunchOutTime).format("hh") + ":" + moment.utc(punchSet.PunchOutTime).format("mm") + " " + moment.utc(punchSet.PunchOutTime).format("a") : ""}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    <div style={{ marginLeft: "auto", marginRight: 20 }} >
                                                        {punchSet.IsGeoFence ? <Exit style={{ fill: AppStateStore.getFrontEndSettings().UISettings.AccentColor, width: 37, height: 37, margin: -1 }} /> :
                                                            <Clock style={{ fill: AppStateStore.getFrontEndSettings().UISettings.AccentColor, width: 37, height: 37, margin: -1 }} />}
                                                    </div>
                                                </div>
                                                <div style={{ width: 640, height: 75, position: "absolute", top: 150, backgroundColor: "#e7e7e7" }}>
                                                    {locations.length === 0 &&
                                                        <span
                                                            style={{ position: "absolute", zIndex: 2000, left: 245, top: 25, fontSize: 15 }}>
                                                            {strings.No_Location_Data}
                                                        </span>
                                                    }
                                                    {locations.length > 0 &&
                                                        <MapLoader locations={locations} />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <span style={{ width: 21, height: 21, backgroundColor: "#CCDBF8", position: "absolute", left: 16, bottom: -10, transform: "rotate(45deg)" }} />
                                        <span style={{ width: 9, height: 9, position: "absolute", left: -3, bottom: -7, borderRadius: "50%", border: "3px solid " + AppStateStore.getFrontEndSettings().UISettings.AccentColor }} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                }
            </div>
        )
    }
}